import { combineReducers } from "redux";
import periodsReducer from "./periodsReducer";
import marketsReducer from "./marketsReducer";
import marketselectedReducer from "./marketselectedReducer";

import marketsWheelReducer from "./marketsWheelReducer";
import regionsReducer from "./regionsReducer";
import errorReducer from "./errorReducer";
import periodCallReducer from "./periodCallReducer";
import periodNumber from "./periodNumber";
import positionReducer from "./positionReducer";
import selectedwheelposition from "./selectedwheelposition";
import compareregionsReducer from "./compareregionsReducer";
import comparemarketslistReducer from "./comparemarketslistReducer";
import comparemarketselectedReducer from "./comparemarketselectedReducer";
import basepathReducer from "./basepathReducer";
import comparisonMarketsReducer from './comparisonMarketsReducer'
import quarterPeriodsReducer from "./quarterPeriodsReducer";

import market from '../redux/reducer/marketReducer'
import userReducer from './userReducer';


export default combineReducers({
  activePeriod: periodsReducer,
  markets: marketsReducer,
  marketselected: marketselectedReducer,
  marketswheel: marketsWheelReducer,
  greaterRegions: regionsReducer,
  errorState: errorReducer,
  periodList: periodCallReducer,
  selected: periodNumber,
  positionselected: positionReducer,
  selectedWheelPosition : selectedwheelposition,
  comparegreaterregion : compareregionsReducer,  // Used in MarketDetail Comparision
  comparemarketslist : comparemarketslistReducer,
  comparemarketselected : comparemarketselectedReducer, // used to set the market selcted for comparison
  basepath : basepathReducer,
  comparisonMarkets:comparisonMarketsReducer,
  quarterPeriods: quarterPeriodsReducer,
  market, //refactor
  user: userReducer
});
